module.exports = __webpack_public_path__ + "static/media/ibd_back2.c1380c6b.png";